
// L이 붙은 경우 localStorage에 저장하여 닫았다가 다시 열었을 때 값을 유지하고, 모든 탭에 적용됨
// 없을 경우 session에 저장하여 각 탭마다 값을 유지하고 있음
class StorageService {
 
  setItem(key, data) {
    // localStorage.setItem(key, JSON.stringify(data));
    sessionStorage.setItem(key, JSON.stringify(data));
  }

  setLItem(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
  }

  getItem(key) {
    // const item = localStorage.getItem(key);
    const item = sessionStorage.getItem(key);
    return JSON.parse(item);
  }

  getLItem(key) {
    const item = localStorage.getItem(key)
    return JSON.parse(item)
  }

  removeItem(key) {
    // localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }

  removeLItem(key) {
    localStorage.removeItem(key);
  }
}
export default new StorageService();